import { render, staticRenderFns } from "./PgAdmin.vue?vue&type=template&id=264922e2&scoped=true"
import script from "./PgAdmin.vue?vue&type=script&lang=js"
export * from "./PgAdmin.vue?vue&type=script&lang=js"
import style0 from "./PgAdmin.vue?vue&type=style&index=0&id=264922e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264922e2",
  null
  
)

export default component.exports